import React from "react";
import { Link } from "react-router-dom";

export default function DonationCancel() {
    return (
        <div className="min-h-screen bg-ink text-white flex items-center justify-center px-6">
            <div className="max-w-xl w-full border border-white/10 bg-inksurface p-10 text-center" data-testid="donation-cancel-page">
                <h1 className="font-display font-black uppercase text-4xl">Donation cancelled</h1>
                <p className="text-zinc-400 mt-4">No charge was made. You can try again whenever you're ready.</p>
                <Link to="/#donate" className="btn-volt inline-block mt-8 px-8 py-4 text-xs">
                    Try again
                </Link>
            </div>
        </div>
    );
}
